import { loggerCan } from '@/data/utils/loggerUtil';
import { ContentType, HttpClient, RequestParams } from './http-client';
import { logger } from '@/logging/logger';
import { DpvalePromotion, PostDpvalePromotionBody } from './data-contracts';

export class Dpvale<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;
	traceDetails: string | undefined;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
		this.traceDetails = process.env.TRACE_DETAILS?.trim();
	}

	/**
	 * @tags transactions
	 * @name postDpvalePromotions
	 * @summary Post obtain information of dpvale promotion by product
	 * @request POST:/store/{storeId}/dpvale/promotions
	 * @secure
	 * @description Post obtain information of dpvale promotion by product
	 */
	postDpvalePromotion = (
		storeId: string,
		query?: {
			/** The response format. Valid values are json and xml. If the request contains an input body, it must use the format specified in responseFormat. If the responseFormat is not specified, the accept  HTTP header determines the format of the response. If the accept  HTTP header is not specified then default response format is json. */
			responseFormat?: 'xml' | 'json';
		},
		data?: PostDpvalePromotionBody,
		params: RequestParams = {}
	) => {
		const { _requestId: requestId } = params as any;
		delete (params as any)._requestId;

		if (
			loggerCan('trace') &&
			(!this.traceDetails || this.traceDetails.includes('postDpvalePromotion'))
		) {
			const paramsLogger = logger.child({
				params,
				query: query ?? {},
				body: data ?? {},
				methodName: 'postDpvalePromotion',
				requestId,
			});
			paramsLogger.trace('API request parameters');
		}
		return this.http.request<DpvalePromotion, void>({
			path: `/store/${storeId}/dpvale/promotions`,
			method: 'POST',
			query: query,
			body: data,
			secure: true,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			...params,
		});
	};
}
